import * as yup from 'yup';
import { UseFormProps } from 'react-hook-form';

import { reDate } from '@shared/lib/regex';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormDataType } from './entrepreneur-edit.types';
import { IPrivateEntrepreneurDetailsBase } from '@entities/employee';
import {
  FUTURE_REGISTRATION_DATE,
  INVALID_DATE_FORMAT,
} from '@modules/employees/shared/constants/form-error.constants';
import { isValidDate } from '@modules/employees/shared/helpers';

const schema = yup
  .object()
  .shape({
    companyName: yup.string().default(''),
    registrationNumber: yup.string().default(''),
    registrationDate: yup
      .string()
      .matches(reDate, {
        excludeEmptyString: true,
        message: INVALID_DATE_FORMAT,
      })
      .test('registrationDate', FUTURE_REGISTRATION_DATE, value =>
        isValidDate(value, {
          extraDays: 14,
        })
      )
      .default(''),
    registrationCountry: yup.string().default(''),
    taxIdentificationNumber: yup.string().default(''),
    addressEn: yup.string().default(''),
    addressUa: yup.string().default(''),
  })
  .required();

export const setup = (defaultValues: IPrivateEntrepreneurDetailsBase) => {
  const options: UseFormProps<FormDataType> = {
    defaultValues: {
      ...defaultValues,
      registrationCountry: defaultValues.registrationCountry.id,
    },
    resolver: yupResolver<FormDataType>(schema),
  };

  return options;
};
